import { render, staticRenderFns } from "./mail-log-side-action.vue?vue&type=template&id=72df97c8"
import script from "./mail-log-side-action.ts?vue&type=script&lang=js&external"
export * from "./mail-log-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports